export default __webpack_public_path__ + "static/product-description_en-ee4eb4cbaf94c3218391921639f328cb.pdf";